import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    empleados: `${API_BASE}/Empleados`,
    empleadosById: (id) => `${API_BASE}/Empleados/${id}`,
    turnos: `${API_BASE}/Turnos`,
    turnosSecurity: (tipo) => `${API_BASE}/Turnos/security?tipo=${tipo}`,
    turnosById: (id) => `${API_BASE}/Turnos/${id}`,
    turnoById: (id) => `${API_BASE}/Turnos/${id}`,
    empleadosTurnos: `${API_BASE}/EmpleadosTurnos`,
    empleadosTurnosById: (id) => `${API_BASE}/EmpleadosTurnos/${id}`,
    puestos: `${API_BASE}/Puestos`,
    puestosSecurity: (tipo) => `${API_BASE}/Puestos/security?tipo=${tipo}`,
    puestosById: (id) => `${API_BASE}/Puestos/${id}`,
    areaNegocio: `${API_BASE}/AreaNegocio`,
    areaNegocioSecurity: (tipo) => `${API_BASE}/AreaNegocio/security?tipo=${tipo}`,
    areaNegocioById: (id) => `${API_BASE}/AreaNegocio/${id}`,
    empresas: `${API_BASE}/Empresas`,
    nivelJerarquico: `${API_BASE}/NivelJerarquico`,
    nivelJerarquicoSecurity: (tipo) => `${API_BASE}/NivelesJerarquicos/security?tipo=${tipo}`,
    nivelJerarquicoById: (id) => `${API_BASE}/NivelesJerarquicos/${id}`,
    zonasGeograficas: `${API_BASE}/ZonasGeograficas`,
    zonasGeograficasSecurity: (tipo) => `${API_BASE}/ZonasGeograficas/security?tipo=${tipo}`,
    zonasGeograficasById: (id) => `${API_BASE}/ZonasGeograficas/${id}`,
};
